import { Dialog, DialogTitle } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  IconButton,
  styled,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../../theme/ThemeContext";
import ViewIcon from "../../Invitations/ViewIcon";
import { countryData, timeZoneData } from "./AddressFormData";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  bottom: -2,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: mode ? "#888B8D" : "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

function SiteViewDialog(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [siteData, setSetData] = React.useState({});
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [sitedetails, setSiteDetails] = React.useState(
    process.env.REACT_APP_ENVIRONMENT === "USA"
      ? {
        [t("COMMON044")]: props.data.name,
        [t("STYPE001")]: props.data.siteTypeName,
        [t("COMMON050")]: props.data.parentName,
        [t("ATYPE009")]: props.data.description,
        [t("ADD001")]: props.data.address.addressLine1,
        [t("ADD002")]: props.data.address.addressLine2,
      }
      : {
        [t("COMMON014")]: props.data.name,
        [t("STYPE001")]: props.data.siteTypeName,
        [t("COMMON050")]: props.data.parentName,
        [t("ATYPE009")]: props.data.description,
        [t("ADD001")]: props.data.address.addressLine1,
        [t("ADD002")]: props.data.address.addressLine2,
        [t("ADD017")]: props.data.address.addressLine3,
        [t("ATYPE001")]: props.data.address.addressTypeName,
      }
  );
  const [addressDetails, setAddressDetails] = React.useState(
    process.env.REACT_APP_ENVIRONMENT === "USA"
      ? {
        [t("ADD005")]: props.data.address.city,
        [t("ADD004")]: props.data.address.state,
        [t("ADD003")]: props.data.address.country,
        [t("DEALERZIPCODE")]: props.data.address.areaCode,
        [t("ADD010")]: props.data.address.timeZone,
        [t("ATYPE001")]: props.data.address.addressTypeName,
      }
      : {
        [t("ADD003")]: props.data.address.country,
        [t("ADD004")]: props.data.address.state,
        [t("ADD005")]: props.data.address.city,
        [t("DEALERZIPCODE")]: props.data.address.areaCode,
        [t("ADD007")]: props.data.address.latitude,
        [t("ADD008")]: props.data.address.longitude,
        [t("ADD009")]: props.data.address.radius,
        [t("ADD010")]: props.data.address.timeZone,
      }
  );
  //  useEffect(() => {
  //   {
  //     process.env.REACT_APP_ENVIRONMENT === "USA"
  //       ? setSiteDetails({
  //           ...sitedetails,
  //           [t("COMMON014")]: props.data.name,
  //           [t("STYPE001")]: props.data.siteTypeName,
  //           [t("COMMON050")]: props.data.parentName,
  //           [t("ATYPE009")]: props.data.description,
  //           [t("ADD001")]: props.data.address.addressLine1,
  //           [t("ADD002")]: props.data.address.addressLine2,
  //         })
  //       : setSiteDetails({
  //           ...sitedetails,
  //           [t("COMMON014")]: props.data.name,
  //           [t("STYPE001")]: props.data.siteTypeName,
  //           [t("COMMON050")]: props.data.parentName,
  //           [t("ATYPE009")]: props.data.description,
  //           [t("ADD001")]: props.data.address.addressLine1,
  //           [t("ADD002")]: props.data.address.addressLine2,
  //           [t("ADD017")]: props.data.address.addressLine3,
  //           [t("ATYPE001")]: props.data.address.addressTypeName,
  //         });
  //   }
  // }, [props.data]);

  useEffect(() => {
    let timeZone = "";

    if (props.data?.timeZone) {
      const matchedTimeZone = timeZoneOptions.find(
        (option) => option.value === props.data.timeZone
      );

      if (matchedTimeZone) {
        timeZone = matchedTimeZone.label;
      } else {
        timeZone = "";
      }
    }

    let country = "";
    countryData.map((item, index) =>
      item.id === props.data.address.country ? (country = item.name) : ""
    );

    {
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? setAddressDetails({
          ...addressDetails,

          [t("ADD003")]: props.data.address.country,
          [t("ADD004")]: props.data.address.state,
          [t("ADD005")]: props.data.address.city,
          [t("DEALERZIPCODE")]: props.data.address.areaCode,
          [t("ATYPE001")]: props.data.address.addressTypeName,
          [t("ADD010")]: timeZone,
        })
        : setAddressDetails({
          ...addressDetails,

          [t("ADD003")]: props.data.address.country,
          [t("ADD004")]: props.data.address.state,
          [t("ADD005")]: props.data.address.city,
          [t("DEALERZIPCODE")]: props.data.address.areaCode,
          [t("ADD007")]: props.data.address.latitude,
          [t("ADD008")]: props.data.address.longitude,
          [t("ADD009")]: props.data.address.radius,
          //  'Time Zone': props.data.address.timeZone,
        });
    }
    //  window.location.reload(false);
  }, [props.data]);

  useEffect(() => {
    let timeZone = "";
    timeZoneData.map((item, index) =>
      item.id === props.data.address.timeZone ? (timeZone = item.name) : ""
    );

    countryData.map(
      (item, index) =>
        item.id === props.data.address.country &&
        setAddressDetails({
          ...addressDetails,
          Country: item.name,
          "Time Zone": timeZone,
        })
    );
    // window.location.reload(false);
  }, []);

  const [dayLightSaving, setDayLightSaving] = React.useState(
    props.data.address.dayLightSaving
  );

  const handleClose = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const timeZoneOptions = Object.entries({
    "(UTC-12:00)International Date Change Line West": "-12:00",
    "(UTC-11:00)Coordinated Universal Time-11": "-11:00",
    "(UTC-10:00)Hawaii": "-10:00",
    "(UTC-09:00)Alaska": "-09:00",
    "(UTC-08:00)Pacific time (American and Canada)  Baja California": "-08:00",
    "(UTC-07:00)La Paz, Massa Rand, The mountain time (American and Canada), Arizona":
      "-07:00",
    "(UTC-06:00)Saskatchewan, Central time, Central America": "-06:00",
    "(UTC-05:00)Bogota, Lima, Quito, Leo Branco, Eastern time, Indiana(East)":
      "-05:00",
    "(UTC-04:30)Caracas": "-04:30",
    "(UTC-04:00)Atlantic time, Cuiaba, Georgetown, La Paz, Santiago": "-04:00",
    "(UTC-03:30)Newfoundland": "-03:30",
    "(UTC-03:00)Brasilia, Buenos Aires, Greenland, Cayenne": "-03:00",
    "(UTC-02:00)The International Date Line West-02": "-02:00",
    "(UTC-01:00)Cape Verde Islands, Azores": "-01:00",
    "(UTC 00:00)Dublin, Edinburgh, Lisbon, London, The International Date Line West":
      "00:00",
    "(UTC+01:00)Amsterdam, Brussels, Sarajevo": "+01:00",
    "(UTC+02:00)Beirut, Damascus, Eastern Europe, Cairo,Athens, Jerusalem":
      "+02:00",
    "(UTC+03:00)Baghdad, Kuwait, Moscow, St Petersburg,Nairobi": "+03:00",
    "(UTC+03:30)Teheran or Tehran": "+03:30",
    "(UTC+04:00)Abu Zabi, Yerevan, Baku, Port Louis, Samarra": "+04:00",
    "(UTC+04:30)Kabul": "+04:30",
    "(UTC+05:00)Ashkhabad, Islamabad, Karachi": "+05:00",
    "(UTC+05:30)Chennai, Calcutta Mumbai, New Delhi": "+05:30",
    "(UTC+05:45)Katmandu": "+05:45",
    "(UTC+06:00)Astana, Dhaka, Novosibirsk": "+06:00",
    "(UTC+06:30)Yangon": "+06:30",
    "(UTC+07:00)Bangkok, Hanoi, Jakarta": "+07:00",
    "(UTC+08:00)Beijing, Chinese Taipei, Irkutsk, Ulan Bator": "+08:00",
    "(UTC+09:00)Osaka, Tokyo, Seoul, Yakutsk": "+09:00",
    "(UTC+09:30)Adelaide, Darwin": "+09:30",
    "(UTC+10:00)Brisbane, Vladivostok, Guam, Canberra": "+10:00",
    "(UTC+11:00)Jo Kul Dah, Solomon Islands, New Caledonia": "+11:00",
    "(UTC+12:00)Anadyr, Oakland, Wellington, Fiji": "+12:00",
    "(UTC+13:00)Nukualofa, The Samoa Islands": "+13:00",
    "(UTC+14:00)Christmas Island": "+14:00",
  }).map(([label, value]) => ({ label, value }));

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const [state, setState] = React.useState(true);

  const handledaylight = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.checked,
    });
  };

  return (
    <>
      <Grid onClick={handleOpen}>
        <ViewIcon darkMode={darkMode} />
      </Grid>
      <Dialog
        open={open}
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "40vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={handleClose} />
          </IconButton>
          <Typography
            style={{
              color: darkMode ? "#fff" : "black",
              fontSize: "20px",
              fontWeight: "450",
            }}
          >
            {t("SITE001")}
          </Typography>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />
        <DialogContent>
          <Grid container spacing={2} style={{ alignItems: 'center' }}>

            <React.Fragment>
              {Object.entries(sitedetails).map(([key, value]) => (
                <Grid item xs={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <Typography variant="body1" style={{ textTransform: 'capitalize' }}>
                        {key}
                      </Typography>
                    </Grid>
                    <Grid item xs={1} style={{ textAlign: 'center' }}>
                      :
                    </Grid>
                    <Grid item xs={6}>
                      <Tooltip title={value}>
                        <Typography variant="body1"
                          style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}>
                          {value}
                        </Typography>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </React.Fragment>

            <React.Fragment>
              {Object.entries(addressDetails).map(([key, value]) => (
                <Grid item xs={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <Typography variant="body1" style={{ textTransform: 'capitalize' }}>
                        {key}
                      </Typography>
                    </Grid>
                    <Grid item xs={1} style={{ textAlign: 'center' }}>
                      :
                    </Grid>
                    <Grid item xs={6}>
                      <Tooltip title={value}>
                        <Typography variant="body1"
                          style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}>
                          {value}
                        </Typography>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </React.Fragment>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            style={{ padding: "10px 20px" }}
          >
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="body1" style={{ marginRight: "8px" }}>
                {t("ADD011")}
              </Typography>
              <Typography variant="body1" style={{ marginRight: "4px" }}>
                {t("DAYLIGHTON")}
              </Typography>
              /
              <Typography variant="body1" style={{ marginLeft: "4px" }}>
                {t("DAYLIGHTOFF")}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
            >
              <Android12Switch
                checked={dayLightSaving}
                onChange={handledaylight}
                name="dayLightSaving"
                mode={darkMode}
              />
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SiteViewDialog;
